import { Component,  Input, OnInit, } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
//import { EmailComposer } from '@ionic-native/email-composer/ngx';
import { NavController } from '@ionic/angular';
@Component({
  selector: 'app-faq',
  templateUrl: './faq.page.html',
  styleUrls: ['./faq.page.scss'],
})

export class FaqPage implements OnInit {
 
  @Input('question') question:any;

  information: any[];
  faqContent;
  headerBranding: String;

  constructor(private http: HttpClient, 
    //private emailComposer: EmailComposer, 
    private navController: NavController) { 
  }
  
  toggleSection(index){
   
    this.information[index].open = !this.information[index].open;
     if (this.information[index].open){
       this.information
       .filter((item, itemIndex) => itemIndex != index)
       .map(item => item.open = false);
    }
    
  }
  contactBallotpedia () {
   this.navController.navigateForward(`/feedback`);
 }
 
  async ngOnInit() {

  let res = await this.http.get('assets/config.json').toPromise();
  this.headerBranding = res["headerBranding"];

   this.faqContent =  this.http.get('assets/faq.json').subscribe(res => {
      this.information = res['items']; 
    });
  }
  
  ngOnDestroy(){
    this.faqContent.unsubscribe();

  }

}
